import { Pipe, PipeTransform } from '@angular/core';
import { DprCard } from '@dpr/models';
import { DprCardService } from '@dpr/services';

@Pipe({ name: 'lockStatus' })
export class LockStatusPipe implements PipeTransform {
  constructor(private dprCardService: DprCardService) {}

  transform(data: DprCard): string {
    if (!data) {
      return null;
    }

    return data.dprDetailLockedDate
      ? this.dprCardService.formatDprDate(data.dprDetailLockedDate)
      : $localize`:@@dpr.lockStatusPipe.txtUnlocked:Unlocked`;
  }
}
